<template>
  <div>
    <div class="intro-y flex items-center mt-8" />
    <div class="block xl:grid grid-cols-2 gap-4">
      <!-- BEGIN: Login Info -->
      <div class="hidden xl:flex flex-col min-h-screen">
        <div class="my-auto">
          <img
              alt="Midone Tailwind HTML Admin Template"
              class="-intro-x w-1/2 -mt-16"
              :src="require(`@/assets/images/illustration.svg`)"
              style="margin-left: 120px;"
          />
          <!--            <div-->
          <!--              class="-intro-x text-white font-medium text-4xl leading-tight mt-10"-->
          <!--            >-->
          <!--           illustration.svg   A few more clicks to <br />-->
          <!--              sign in to your account.-->
          <!--            </div>-->
          <br />
          <div class="p-5 border-t border-gray-200 dark:border-dark-5" style="margin-left: 110px; margin-right: 80px;margin-bottom: 60px;">
            <div class="font-medium">
              Don’t waste your time, expertise and money transcribing the PMST results pdf. Login and we will do it for you.
            </div>
          </div>
        </div>
      </div>
      <!-- END: Login Info -->
      <!-- BEGIN: Login Form -->
      <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
        <div
            class="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
        >
          <h2
              class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
          >
            Login
          </h2>
          <div class="intro-x mt-8">
            <input
                v-model="user.email"
                type="text"
                class="intro-x login__input w-full input input--lg border border-gray-300 block"
                placeholder="Email"
            />
            <input
                v-model="user.password"
                type="password"
                class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
                placeholder="Password"
            />
          </div>
          <div
              class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4"
          >
            <!--              <div class="flex items-center mr-auto">-->
            <!--                <input-->
            <!--                  id="remember-me"-->
            <!--                  type="checkbox"-->
            <!--                  class="input border mr-2"-->
            <!--                />-->
            <!--&lt;!&ndash;                <label class="cursor-pointer select-none" for="remember-me"&ndash;&gt;-->
            <!--                  >Remember me</label-->
            <!--                >-->
            <!--              </div>-->
                          <a href="/reset-form">Forgot Password?</a>
          </div>
          <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
            <button
                class="button button--lg w-full xl:w-32 text-white bg-theme-1 xl:mr-3 align-top"
                @click="handleSubmit"
            >
              Login
            </button>
            <router-link to="/register">
              <button
                  class="button button--lg w-full xl:w-32 text-gray-700 border border-gray-300 dark:border-dark-5 dark:text-gray-300 mt-3 xl:mt-0 align-top"
              >
                Sign up
              </button>
            </router-link>
            <div
                class="intro-x mt-10 xl:mt-24 text-gray-700 dark:text-gray-600 text-center xl:text-left"
            >
              By logging in, you agree to our <br />
              <a class="text-theme-1 dark:text-theme-10" href="/terms"
              >Terms and Conditions</a
              >
            </div>
          </div>
          <br/>
          <br/>
          <div
              v-if="infoError === true "
              class="rounded-md flex items-center px-5 py-4 mb-2 bg-theme-6 text-white"
          >
            <AlertOctagonIcon class="w-6 h-6 mr-2" />
            Email or password provided is incorrect
          </div>
        </div>
      </div>
      <!-- END: Login Form -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AuthService from '../services/Auth';
const authService = new AuthService();

export default {
  data() {
    return {
      loader: false,
      infoError: false,
      user: {
        email: '',
        password: ''
      }
    };
  },
  mounted() {
    // cash("body")
    //   .removeClass("app")
    //   .addClass("login");
    this.isLogedin();
  },
  methods: {
    isLogedin() {
      let jwt = authService.getToken();
      let user = authService.getUser();
      let refresh = authService.getRefresh();

      if (jwt && user && refresh) {
        this.$router.push("user-pdf");
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      let self = this
      if (self.user.password.length > 0) {
        axios
          .post("token/obtain/", {
            email: self.user.email,
            password: self.user.password
          })
          .then(response => {
            let is_admin = response.data.user.is_superuser;
            authService.setRefresh(response.data.refresh);
            authService.setToken(response.data.access);
            authService.setUser(response.data.user);
            if (authService.getToken() != null) {
              self.$emit("loggedIn");
              if (self.$route.params.nextUrl != null) {
                self.$router.push(self.$route.params.nextUrl);
              } else {
                if (is_admin === true) {
                  // this.$router.push("admin");
                  self.$router.push("admin-aria");
                } else {
                  self.$router.push("user-pdf");
                }
              }
            }
          })
          .catch(function(error) {
            console.error(error.response);
            self.infoError = true
          });
      }
    }
  }
};
</script>
